import React from 'react'

export const WarningIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="7"
      height="31"
      viewBox="0 0 7 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.4375 30.9375C2.49219 30.9375 1.68294 30.6009 1.00977 29.9277C0.336589 29.2546 0 28.4453 0 27.5C0 26.5547 0.336589 25.7454 1.00977 25.0723C1.68294 24.3991 2.49219 24.0625 3.4375 24.0625C4.38281 24.0625 5.19206 24.3991 5.86523 25.0723C6.53841 25.7454 6.875 26.5547 6.875 27.5C6.875 28.4453 6.53841 29.2546 5.86523 29.9277C5.19206 30.6009 4.38281 30.9375 3.4375 30.9375ZM0 20.625V0H6.875V20.625H0Z"
        fill="white"
      />
    </svg>
  )
}
